import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const AiLight16 = ({ height = 20, width = 20, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 20 20" {...props}>
    <g filter="url(#filter0_ddd_18064_59046)">
      <rect x="2" y="2" width="16" height="16" rx="4" fill="white" shapeRendering="crispEdges" />
      <g filter="url(#filter1_dii_18064_59046)">
        <path
          d="M7.35009 10.6766L9.61111 11.3125L9.90278 14.2657C9.93416 14.5834 10.3511 14.6795 10.5184 14.4076L13.0372 10.3146C13.2692 9.93755 13.0761 9.44327 12.6499 9.32341L10.3889 8.6875L10.0972 5.73432C10.0658 5.41664 9.64892 5.32051 9.48161 5.59238L6.96282 9.68542C6.7308 10.0624 6.92393 10.5567 7.35009 10.6766Z"
          fill="url(#paint0_linear_18064_59046)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_ddd_18064_59046"
        x="0"
        y="0"
        width="20"
        height="20"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_18064_59046" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_18064_59046"
          result="effect2_dropShadow_18064_59046"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_18064_59046"
          result="effect3_dropShadow_18064_59046"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_18064_59046"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dii_18064_59046"
        x="6.71353"
        y="5.43335"
        width="6.57295"
        height="9.4333"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.15" />
        <feGaussianBlur stdDeviation="0.075" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_18064_59046" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_18064_59046"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_18064_59046" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_18064_59046"
          result="effect3_innerShadow_18064_59046"
        />
      </filter>
      <linearGradient
        id="paint0_linear_18064_59046"
        x1="12.7345"
        y1="4.75"
        x2="4.38516"
        y2="11.8744"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4D80" />
        <stop offset="0.0667" stopColor="#FE4D81" />
        <stop offset="0.1333" stopColor="#FC4E82" />
        <stop offset="0.2" stopColor="#F95086" />
        <stop offset="0.2667" stopColor="#F4528A" />
        <stop offset="0.3333" stopColor="#EE5490" />
        <stop offset="0.4" stopColor="#E65897" />
        <stop offset="0.4667" stopColor="#DE5B9F" />
        <stop offset="0.5333" stopColor="#D65FA7" />
        <stop offset="0.6" stopColor="#CE62AF" />
        <stop offset="0.6667" stopColor="#C666B6" />
        <stop offset="0.7333" stopColor="#C068BC" />
        <stop offset="0.8" stopColor="#BB6AC0" />
        <stop offset="0.8667" stopColor="#B86CC4" />
        <stop offset="0.9333" stopColor="#B66DC5" />
        <stop offset="1" stopColor="#B56DC6" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
